import {  CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ProductoComponent } from './componentes/producto/producto.component';
import { CajasComponent } from './componentes/cajas/cajas.component';
import { DetalleproductComponent } from './componentes/detalleproduct/detalleproduct.component';
import { FotosComponent } from './componentes/fotos/fotos.component';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery/ngx';
import { FotosdentroComponent } from './componentes/fotosdentro/fotosdentro.component';
import { DedicatoriaComponent } from './componentes/dedicatoria/dedicatoria.component';

import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule } from '@angular/common/http';
//import * as firebase from 'firebase';
import * as firebase from 'firebase';
import { PagoComponent } from './componentes/pago/pago.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { TerminosComponent } from './componentes/terminos/terminos/terminos.component';
import { PoliticasComponent } from './componentes/politicas/politicas/politicas.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//zonn imagenes
import { NgxIonicImageViewerModule } from 'ngx-ionic-image-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress-legacy';
//import { NgxImageCompressService } from 'ngx-image-compress';
import { IonIntlTelInputModule } from 'ion-intl-tel-input';
import { PrincipalPipe } from './principal.pipe';
import { TolbarComponent } from './componentes/tolbar/tolbar.component';
import { CarruselComponent } from './componentes/carrusel/carrusel.component';
import { GroupproductPipe } from './pipes/groupproduct.pipe';
import { SubiraudioComponent } from './componentes/subiraudio/subiraudio.component';

const config = {
  apiKey: "AIzaSyAXZ7QfaIEm0yNdZbhBPmM4ew1fDf7VVag",
    authDomain: "cajapeluche.firebaseapp.com",
    databaseURL: "https://cajapeluche.firebaseio.com",
    projectId: "cajapeluche",
    storageBucket: "cajapeluche.appspot.com",
    messagingSenderId: "637007703816",
    appId: "1:637007703816:web:17a24518b61003446086bd",
    measurementId: "G-X5C4ETCRLV"
};
// Initialize Firebase
firebase.initializeApp(config);
const db = firebase.firestore();
db.enablePersistence();

@NgModule({
  declarations: [ AppComponent, ProductoComponent, CajasComponent,
                  DetalleproductComponent, FotosComponent, FotosdentroComponent, 
                  DedicatoriaComponent, PagoComponent,
                  TerminosComponent, PoliticasComponent, PrincipalPipe, CarruselComponent, GroupproductPipe, SubiraudioComponent],

  entryComponents: [ProductoComponent, CajasComponent, DetalleproductComponent, 
                    FotosComponent, FotosdentroComponent,
                    DedicatoriaComponent, PagoComponent, TerminosComponent,
                    PoliticasComponent, CarruselComponent, SubiraudioComponent],

  imports: [BrowserModule, 
            RecaptchaModule, 
            HttpClientModule, 
            //IonicPageModule.forChild(HomePage),
            IonIntlTelInputModule,
            IonicModule.forRoot(), 
            AppRoutingModule,
            BrowserAnimationsModule,
            NgxIonicImageViewerModule,
            
    /* IonCustomScrollbarModule, */
    ReactiveFormsModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })],  
  providers: [
    StatusBar,
    NgxImageCompressService,
    Base64ToGallery,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
